module.exports = __webpack_public_path__ + "img/20191217163615397.a1955cdc.jpg";